import { render, staticRenderFns } from "./NavigationBarIcon.vue?vue&type=template&id=37b06764&scoped=true&"
import script from "./NavigationBarIcon.vue?vue&type=script&lang=js&"
export * from "./NavigationBarIcon.vue?vue&type=script&lang=js&"
import style0 from "./NavigationBarIcon.vue?vue&type=style&index=0&id=37b06764&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b06764",
  null
  
)

export default component.exports